if (!customElements.get('hsg-offer-copy')) {
  customElements.define('hsg-offer-copy', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-offer-copy]');
      this.status = this.querySelector('[data-offer-status]');
      this.copyCode = async () => {
        const code = this.querySelector('[data-offer-code]');
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
          this.status.textContent = this.button.dataset.copied;
          this.button.textContent = this.button.dataset.copied;
        } catch {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection?.removeAllRanges();
          selection?.addRange(range);
          this.status.textContent = this.button.dataset.copyFailed;
          this.button.textContent = this.button.dataset.copyFailed;
        }
      };
      this.button.addEventListener('click', this.copyCode);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.copyCode);
    }
  });
}
